module.exports = __webpack_public_path__ + "a04cba72d4b7329013086aa3c443db11.svg";